<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span>
					<em class="lt_text mgr_5">Row By</em>
					<select class="int_type" v-model="row_by" @change="changeGroupBy">
						<option value="CUSTOMER">Customer</option>
						<option value="ITEM">Item</option>
						<option value="CUSTOMER_ITEM">Customer&Item</option>
						<option value="INVOICE">Invoice</option>
						<option :value="null">Invoice Item</option>
					</select>
				</span>

				<span class="mgl_15">
					<em class="lt_text mgr_5">Subtotal</em>
					<template v-if="group_by_only_customer">
						<label class="mgr_5"><input type="radio" value="SALES_GROUP" v-model="subtotal" /> Sales Group</label>
						<label class="mgr_5"><input type="radio" value="STATE" v-model="subtotal" /> State</label>
					</template>
					<template v-if="group_by_only_item">
						<label class="mgr_5"><input type="radio" value="ITEM_CLASS" v-model="subtotal" /> Item {{ headers.class }}</label>
					</template>
					<template v-if="group_by_customer_item">
						<label class="mgr_5"><input type="radio" value="CUSTOMER" v-model="subtotal" /> Customer</label>
						<label class="mgr_5"><input type="radio" value="ITEM_CLASS" v-model="subtotal" /> Item {{ headers.class }}</label>
					</template>
					<template v-if="group_by_invoice">
						<label class="mgr_5"><input type="radio" value="SALES_GROUP" v-model="subtotal" /> Sales Group</label>
					</template>
					<template v-if="group_by_none">
						<label class="mgr_5"><input type="radio" value="INVOICE" v-model="subtotal" /> Invoice</label>
					</template>
					<label class="mgr_5"><input type="radio" :value="null" v-model="subtotal" /> None</label>
				</span>

				<span class="mgl_15">
					<em class="lt_text mgr_5">Invoice Issued</em>
					<label class="mgr_5"><input type="radio" value="A" v-model="inv_issued_option" /> All</label>
					<label class="mgr_5"><input type="radio" value="I" v-model="inv_issued_option" /> Issued</label>
					<label class="mgr_5"><input type="radio" value="U" v-model="inv_issued_option" /> Not issued</label>
				</span>
				<span class="mgl_15">
					<em class="lt_text mgr_5">Invoice Type</em>
					<label class="mgr_5"><input type="checkbox" v-model="include_s_inv" /> Sales</label>
					<label class="mgr_5"><input type="checkbox" v-model="include_r_inv" /> Return</label>
					<label class="mgr_5"><input type="checkbox" v-model="include_c_inv" /> Credit</label>
					<label class="mgr_5"><input type="checkbox" v-model="include_b_inv" /> Bounce</label>
				</span>

				<label class="mgl_15">
					<em class="lt_text">Record</em>
					<span class="int_type_no_border mgr_5">
						<currency-input type="text" v-model="record_count" :precision="0" class="tbl_int ssm_int al_right" />
					</span>
				</label>
				<label class="mgl_5">
					<em class="lt_text">Order By</em>
					<span class="mgr_5">
						<select class="int_type" v-model="sort_key">
							<option value="quantity">Quantity</option>
							<option value="amount">Amount</option>
						</select>
					</span>
				</label>
				<label class="mgl_5">
					<em class="lt_text">Sort</em>
					<span class="mgr_5">
						<select class="int_type" v-model="sort_direction">
							<option value="DESC">DESC</option>
							<option value="ASC">ASC</option>
						</select>
					</span>
				</label>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<!-- <em class="lt_text">Sales Date</em> -->
				<span class="mgr_5">
					<select v-model="date_type" class="tbl_select" style="width:100px;">
						<option value="S">Sales Date</option>
						<option value="I">Invoice Date</option>
					</select>
				</span>
				<span class="mgr_5">
					<CustomDatePicker v-model="date_from" /> ~
					<CustomDatePicker v-model="date_to" />
				</span>

				<span class="mgr_5">
					<select v-model="customer_type" class="tbl_select" style="width:100px;">
						<option value="SHIP_TO">Ship To</option>
						<option value="BILL_TO">Bill To</option>
					</select>
				</span>
				<span class="int_type_no_border mgr_5">
					<PartnerSelect ph="Customer" :showName="false" v-model="search_partner_string" @set-partner="setPartner" />
				</span>
				<span class="int_type mgr_15" style="width:300px;">
					<input type="text" v-model.trim="partners_string" autocomplete="off" @focus="$event.target.select()" />
				</span>

				<CountrySelect v-model.trim="country" :bool="false" />

				<state-select v-model.trim="state" :country="country" />

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code" />
				</span>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<span class="mgr_10">
					<item-class-group v-model.trim="class_group_code" :headers="headers" :disabled="only_amount" />
				</span>

				<em class="lt_text">Item {{ headers.class }}</em>

				<span class="int_type" style="width:350px;">
					<AC
						ref="ac"
						:disableInput="only_amount"
						:inputClass="{ bg_disabled: only_amount }"
						:initialDisplay="class_keyword"
						:source="selectClasses"
						@selected="selectClass"
						results-display="code_name"
						placeholder="Item / Class Name or Code"
					>
					</AC>
				</span>

				<span class="int_type_no_border mgr_5">
					<ItemClassKeywordSearch @setClassList="addSearchingItemClasses" :customPlaceholder="`${headers.class} Code Starting with Keyword`" :disabled="only_amount" />
				</span>

				<span class="int_type_no_border mgr_15">
					<ItemClassSelectMulti v-model.trim="item_classes_string" :selectOnClick="false" :width="300" @keydown="search" :disabled="only_amount" />
				</span>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<span class="int_type_no_border mgr_15">
					<ItemSelectMulti :disabled="only_amount" v-model.trim="selected_items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>
				<em class="lt_text">Item Color</em>
				<span class="int_type">
					<input type="text" :disabled="only_amount" :class="{ bg_disabled: only_amount }" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>

				<a href="javascript:;" class="search_bt mgl_15" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>

				<label class="mgl_15">
					<input type="checkbox" v-model="only_amount" :disabled="!group_by_only_customer" />
					<span>Relates Only to Account.</span>
				</label>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%;">
				<CommonTable :tbl_headers="tbl_headers" :data="row_data" @linkColor="linkColor" @linkInvoice="linkInvoice" @linkSO="linkSO" @linkShipTo="linkShipTo" @linkBillTo="linkBillTo" @linkCustomer="linkCustomer" />
			</div>
		</div>

		<div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="search_bt" @click="exportExcel">Excel</a>
		</div>
	</div>
</template>

<script>
import { apiInvoiceIndex } from '@/api/sales/invoice.js';
import { apiSelectSalesOverviewByCustomer, apiSelectSalesOverviewByItem, apiSelectSalesOverviewByCustomerItem, apiSelectSalesOverviewByInvoice, apiSelectSalesOverviewByInvoiceItem } from '@/api/report/report.js';
import { daysAgo, isDate, today, toDate, dateDiff } from '@/utils/date.js';
import { inputSelectOnClick } from '@/utils/etc.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import AC from '@/components/common/AC';
import StateSelect from '@/components/common/StateSelect';
import CountrySelect from '@/components/common/CountrySelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
import ItemClassKeywordSearch from '@/components/common/ItemClassKeywordSearch';
import ItemClassGroup from '@/components/common/ItemClassGroup';

export default {
	props: ['headers'],
	data: function() {
		return {
			row_by: 'CUSTOMER',
			subtotal: null,

			inv_issued_option: 'A',
			include_s_inv: true,
			include_r_inv: false,
			include_c_inv: false,
			include_b_inv: false,

			record_count: null,
			sort_key: 'amount',
			sort_direction: 'DESC',

			date_type: 'S',
			date_from: daysAgo(14),
			date_to: today(),
			customer_type: 'SHIP_TO',
			partners_string: '',
			country: '',
			state: '',
			sales_group_code: null,

			class_group_code: '',
			class_keyword: null,
			item_classes_string: '',

			selected_items_str: '',
			colors_string: '',
			only_amount: false,

			separator: ',',

			row_data: [],
			tbl_headers: [],

			save_param: {},
			selectedItemId: null,
			salesGroups: [],

			search_partner_string: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		selected_item_codes() {
			return this.selected_items_str ? this.selected_items_str.split(this.separator) : [];
		},
		partners() {
			return this.partners_string ? this.partners_string.split(this.separator) : [];
		},
		item_classes() {
			return this.item_classes_string ? this.item_classes_string.split(/ |,/) : [];
		},
		colors() {
			return this.colors_string ? this.colors_string.split(this.separator) : [];
		},
		group_by_only_customer() {
			return this.row_by === 'CUSTOMER';
		},
		group_by_only_item() {
			return this.row_by === 'ITEM';
		},
		group_by_customer_item() {
			return this.row_by === 'CUSTOMER_ITEM';
		},
		group_by_invoice() {
			return this.row_by === 'INVOICE';
		},
		group_by_none() {
			return !this.row_by;
		},
	},
	components: {
		CommonTable,
		CountrySelect,
		StateSelect,
		CustomDatePicker,
		CodeSelect,
		PartnerSelect,
		ItemClassSelectMulti,
		ItemSelectMulti,
		ItemClassKeywordSearch,
		ItemClassGroup,
		AC,
	},
	methods: {
		reset() {
			this.row_by = 'CUSTOMER';
			this.subtotal = null;

			this.inv_issued_option = 'A';
			this.include_s_inv = true;
			this.include_r_inv = false;
			this.include_c_inv = false;
			this.include_b_inv = false;

			this.record_count = null;
			this.sort_key = 'amount';
			this.sort_direction = 'DESC';

			this.date_type = 'S';
			this.date_from = daysAgo(14);
			this.date_to = today();
			this.customer_type = 'SHIP_TO';
			this.partners_string = '';
			this.country = null;
			this.state = null;
			this.sales_group_code = null;

			this.class_group_code = '';
			this.class_keyword = null;
			this.item_classes_string = '';

			this.selected_items_str = '';
			this.colors_string = '';
			this.only_amount = false;
		},
		changeGroupBy() {
			this.subtotal = null;
			if (!this.group_by_only_customer) {
				this.only_amount = false;
			}
		},
		addSearchingItemClasses(itemClassList) {
			if (!itemClassList || !itemClassList.length) return;
			this.item_classes_string = itemClassList.map(cls => cls.code).join(this.separator);
		},
		selectClasses(input) {
			return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += this.separator + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
		},
		setPartner(partner) {
			if (this.partners_string) this.partners_string += this.separator + partner.code;
			else this.partners_string = partner.code;
		},

		linkColor(data) {
			const class_code = data.class_code;
			const color_code = data.color_code;

			if (!class_code || !color_code) return;

			let routeData = this.$router.resolve({ name: 'salesGoods', query: { class_code: class_code, color_code: color_code } });
			window.open(routeData.href, 'herp_sales_goods');
		},
		linkInvoice(data) {
			const invoice_no = data.invoice_no;

			if (!invoice_no) return;

			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { invoice_no: invoice_no } });
			window.open(routeData.href, '_blank');
		},
		linkSO(data) {
			const invoice_no = data.invoice_no;

			if (!invoice_no) return;

			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { invoice_no: invoice_no } });
			window.open(routeData.href, '_blank');
		},
		linkShipTo(data) {
			const ship_to_code = data.ship_to_code;

			if (!ship_to_code) return;

			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { code: ship_to_code } });
			window.open(routeData.href, 'herp_partner');
		},
		linkBillTo(data) {
			const bill_to_code = data.bill_to_code;

			if (!bill_to_code) return;

			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { code: bill_to_code } });
			window.open(routeData.href, 'herp_partner');
		},
		linkCustomer(data) {
			const customer_code = data.customer_code;

			if (!customer_code) return;

			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { code: customer_code } });
			window.open(routeData.href, 'herp_partner');
		},

		async search() {
			if (!this.checkSearchCondition()) return;

			this.makeParam();

			let response = null;
			// Group by Customer
			if (this.group_by_only_customer) {
				response = await apiSelectSalesOverviewByCustomer(this.save_param);
			}
			// Group by Item
			else if (this.group_by_only_item) {
				response = await apiSelectSalesOverviewByItem(this.save_param);
			}
			// Group by Customer & Item
			else if (this.group_by_customer_item) {
				response = await apiSelectSalesOverviewByCustomerItem(this.save_param);
			}
			// Group by Invoice
			else if (this.group_by_invoice) {
				response = await apiSelectSalesOverviewByInvoice(this.save_param);
			}
			// Group by None
			else if (this.group_by_none) {
				response = await apiSelectSalesOverviewByInvoiceItem(this.save_param);
			}

			if (response) {
				// Total, Subtotal에 배경색 추가
				response.data.forEach(el => {
					if (!el.ranking) {
						el.tr_class = 'bg_gray';
						el.id = 'total';
					}
				});

				this.row_data = response.data;
				this.makeTblHeaders();
			} else {
				this.$toast.error('Network Error.');
			}
		},
		checkSearchCondition() {
			if (!this.date_from || !isDate(this.date_from)) {
				this.$toast.error('Invalid date');
				return false;
			}

			if (!this.date_to || !isDate(this.date_to)) {
				this.$toast.error('Invalid date');
				return false;
			}

			var date_from = toDate(this.date_from);
			var date_to = toDate(this.date_to);

			if (this.partners.length === 0 && this.selected_item_codes.length === 0 && this.item_classes.length === 0 && dateDiff(date_from, date_to) > 60) {
				this.$toast.error('Maximum search period without item and partner condition is 60 days');
				return false;
			}

			return true;
		},
		makeTblHeaders() {
			// Group by Customer + Relates Only to Amount
			if (this.group_by_only_customer && this.only_amount) {
				// Customer Code, Customer Name, State, Sales Group, Payment Terms, Delivery Type,
				// Invoice Amount, Shipped Amount, Shipping Charge, Other Charge, Discount, Balance, Order Count
				this.tbl_headers = [
					{ key: 'customer_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkCustomer' },
					{ key: 'customer_name', name: 'Customer Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkCustomer' },
					{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center', editable: true },
					{ key: 'sales_group_code', name: 'SalesGroup', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'payment_term_code', name: 'Pay Term', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'delivery_type_code', name: 'Delivery', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'invoice_amount', name: 'Invoice Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipping_charge', name: 'Ship Charge', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'extra_charge', name: 'Other Charge', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'special_discount', name: 'Discount', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'balance', name: 'Balance', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'invoice_count', name: 'Order Cnt', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				];
			}

			// Group by Customer + Relates Only to Amount X
			if (this.group_by_only_customer && !this.only_amount) {
				// Customer Code, Customer Name, State, Sales Group, Payment Terms,
				// Order Quantity, Order Amount, Shipped Quantity, Shipped Amount, Cost, Margin, Margin Percent, Invoice Count
				this.tbl_headers = [
					{ key: 'customer_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkCustomer' },
					{ key: 'customer_name', name: 'Customer Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkCustomer' },
					{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center', editable: true },
					{ key: 'sales_group_code', name: 'SalesGroup', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'payment_term_code', name: 'Pay Term', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'total_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_cost', name: 'Cost', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'margin', name: 'Margin', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'margin_percent', name: 'Margin(%)', hidden: !this.user.fob_price_view, width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'invoice_count', name: 'Order Cnt', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				];
			}

			// Group by Item
			else if (this.group_by_only_item) {
				// Class Code, Class Name, Color Code, Item Name,
				// Order Quantity, Order Amount, Shipped Quantity, Shipped Amount, Avg Price, Cost, Margin, Margin Percent
				this.tbl_headers = [
					{ key: 'class_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'class_name', name: `${this.headers.class} Name`, width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkColor' },
					{ key: 'item_name', name: 'Item Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkColor' },
					{ key: 'total_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'avg_price', name: 'Avg Price', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_cost', name: 'Cost', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'margin', name: 'Margin', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'margin_percent', name: 'Margin(%)', hidden: !this.user.fob_price_view, width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}

			// Group by Customer & Item
			else if (this.group_by_customer_item) {
				// Customer Code, Customer Name, Class Code, Class Name, Color Code,
				// Order Quantity, Order Amount, Shipped Quantity, Shipped Amount, Avg Price, Last Shipment Price, Shipment Amount, Return Quantity
				// Gross Profit, Gross Profit Percent
				this.tbl_headers = [
					{ key: 'customer_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkCustomer' },
					{ key: 'customer_name', name: 'Customer Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkCustomer' },
					{ key: 'class_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'class_name', name: `${this.headers.class} Name`, width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkColor' },
					{ key: 'total_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'avg_price', name: 'Avg Price', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'last_shipment_price', name: 'Last SH P.', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipment_price_amount', name: 'Sh P. Amt', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_return_quantity', name: 'Rtn Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'gross_profit', name: 'Gross Profit', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'gross_profit_percent', name: 'GP(%)', hidden: !this.user.fob_price_view, width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}

			// Group by Invoice
			else if (this.group_by_invoice) {
				this.tbl_headers = [
					{ key: 'invoice_dn', name: 'Invoice', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkInvoice' },
					{ key: 'invoice_date', name: 'Invoice Date', width: 20, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, display_filter: 'convertYMDToMDY' },
					{ key: 'delivery_pick_up_date', name: 'Ship Date', width: 20, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, display_filter: 'convertYMDToMDY' },
					{ key: 'so_dn', name: 'SO', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkSO' },
					{ key: 'so_date', name: 'SO Date', width: 20, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, display_filter: 'convertYMDToMDY' },
					{ key: 'ship_to_code', name: 'Ship to', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkShipTo' },
					{ key: 'bill_to_code', name: 'Bill to', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkBillTo' },
					{ key: 'sales_group_code', name: 'SalesGroup', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'total_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_scant_quantity', name: 'Back Ord Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'total_scant_amount', name: 'Back Ord Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}

			// Group by None
			else if (this.group_by_none) {
				// Invoice DN, Invoice Date, SO DN, SO Date, Ship to, Bill to, Class Code, Class Name, Color Code,
				// Order Quantity, Order Amount, Shipped Quantity, Shipped Amount, Unit Price, Cost, Margin, Margin Percent
				this.tbl_headers = [
					{ key: 'invoice_dn', name: 'Invoice', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkInvoice' },
					{ key: 'invoice_date', name: 'Invoice Date', width: 20, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, display_filter: 'convertYMDToMDY' },
					{ key: 'so_dn', name: 'SO', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkSO' },
					{ key: 'so_date', name: 'SO Date', width: 20, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, display_filter: 'convertYMDToMDY' },
					{ key: 'ship_to_code', name: 'Ship to', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkShipTo' },
					{ key: 'bill_to_code', name: 'Bill to', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkBillTo' },
					{ key: 'class_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'class_name', name: `${this.headers.class} Name`, width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkColor' },
					{ key: 'quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'unit_price', name: 'Unit Price', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'cost', name: 'Cost', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'margin', name: 'Margin', hidden: !this.user.fob_price_view, width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'margin_percent', name: 'Margin(%)', hidden: !this.user.fob_price_view, width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}
		},
		makeParam() {
			this.save_param = {
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				limit_yn: this.record_count ? 'Y' : 'N',
				start_index: 0,
				limit_size: this.record_count,
				subtotal: this.subtotal,
				customer_type: this.customer_type,
				include_s_inv: this.include_s_inv,
				include_r_inv: this.include_r_inv,
				include_c_inv: this.include_c_inv,
				include_b_inv: this.include_b_inv,
				inv_issued_option: this.inv_issued_option,
				so_date_from: this.date_type === 'S' ? this.date_from : null,
				so_date_to: this.date_type === 'S' ? this.date_to : null,
				invoice_date_from: this.date_type === 'I' ? this.date_from : null,
				invoice_date_to: this.date_type === 'I' ? this.date_to : null,
				ship_to_code: this.customer_type === 'SHIP_TO' && this.partners.length === 1 ? this.partners[0] : null,
				bill_to_code: this.customer_type === 'BILL_TO' && this.partners.length === 1 ? this.partners[0] : null,
				ship_tos: this.customer_type === 'SHIP_TO' && this.partners.length > 1 ? this.partners : null,
				bill_tos: this.customer_type === 'BILL_TO' && this.partners.length > 1 ? this.partners : null,
				sales_group_code: this.sales_group_code,
				country: this.country,
				state: this.state,
				item_classes: this.item_classes,
				item_codes: this.selected_item_codes,
				color_codes: this.colors,
				class_group_code: this.class_group_code,
			};

			if (this.only_amount) {
				this.$toast.info('Search by Excluding Item Search Criteria.');

				this.save_param.item_classes = null;
				this.save_param.item_codes = null;
				this.save_param.color_codes = null;
				this.save_param.class_group_code = null;
			}
		},

		async exportExcel() {
			exportDataExcel(this.row_data, this.tbl_headers, 'SalesOverview');
		},

		async init() {
			const { data } = await apiInvoiceIndex();
			this.salesGroups = data.salesGroupList;
		},
	},
	mounted() {
		inputSelectOnClick();
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_sales_overview');
		this.$store.commit('setSubTitle', 'Report -> Sales Overview');

		this.init();
	},
};
</script>

<style></style>
